/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {AoaBoardSubspecialty} from './aoa-board-subspecialty.model';
import {Service} from '../../../../common/service.class';
import {Observable, ReplaySubject} from 'rxjs';
import {Response} from '@angular/http';
import {Model} from '../../../../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

@Injectable()
export class AoaBoardSubspecialtyService {

    private _service: Service;

    private _changesSubject$ = new ReplaySubject<boolean>(1);
    changes$: Observable<boolean> = this._changesSubject$;

    protected readonly _modelType = AoaBoardSubspecialty;
    private readonly _basePath: string = 'currentUser';

    constructor(svcm: Service.InjectedMembers) {
        this._service = new Service(svcm, 'aoaBoard');
    }

    doesCurrentUserModelEntryExist(aoaIndex: number, index: number): Observable<boolean> {
        return this._service.exists(this._modelType, this._pathFor(aoaIndex, index));
    }

    getCurrentUserModelEntry(aoaIndex: number, index: number, projection?: ProjectionInformation): Observable<AoaBoardSubspecialty|undefined> {
        return this._service.get(this._modelType, this._pathFor(aoaIndex, index), projection);
    }

    updateCurrentUserModelEntry(aoaIndex: number, index: number, model: AoaBoardSubspecialty): Observable<Response> {
        return this._service.update(model, this._pathFor(aoaIndex, index)).do(() => this._changesSubject$.next(true));
    }

    countCurrentUserModelEntries(aoaIndex: number): Observable<number> {
        return this._service.count(this._modelType, this._pathFor(aoaIndex));
    }

    private _pathFor(aoaIndex: number, index?: number) {
        return index !== undefined ? `${this._basePath}/${aoaIndex}/sub/${index}` : `${this._basePath}/${aoaIndex}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/aoa/subspecialty/aoa-board-subspecialty.service.ts